import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';

import ArticleCard from './ArticleCard';

function ArticleList({
  initialArticleListData,
  getArticles,
  querySpecification,
}) {
  const [state, setState] = useState({
    articles: initialArticleListData.rows,
    infiniteScroll: {
      currentPage: 1,
      totalPages: initialArticleListData.totalPages,
      hasMore: true,
    },
  });

  const loadMoreArticles = async (querySpec, page) => {
    const data = await getArticles(querySpec, page);

    setState({
      articles: data.page === 1 ? data.rows : [...state.articles, ...data.rows],
      infiniteScroll: {
        currentPage: data.page,
        totalPages: data.totalPages,
        hasMore: data.page < data.totalPages,
      },
    });
  };

  const loadNextPage = async filterParams => {
    const { currentPage, totalPages } = state.infiniteScroll;
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      await loadMoreArticles(filterParams, nextPage);
    }
  };

  useEffect(() => {
    setState({
      articles: initialArticleListData.rows,
      infiniteScroll: {
        currentPage: initialArticleListData.page,
        totalPages: initialArticleListData.totalPages,
        hasMore:
          initialArticleListData.page < initialArticleListData.totalPages,
      },
    });
  }, [initialArticleListData]);
  const { infiniteScroll, articles } = state;

  return (
    <Row className="g-0">
      <Col>
        <InfiniteScroll
          pageStart={0}
          loadMore={() => loadNextPage(querySpecification)}
          hasMore={infiniteScroll.hasMore}
        >
          <Row className="g-0">
            {articles.map(article => (
              <Col xs={12} md={4} key={article.id} className="p-1">
                <ArticleCard article={article} />
              </Col>
            ))}
          </Row>
        </InfiniteScroll>
      </Col>
    </Row>
  );
}

ArticleList.propTypes = {
  initialArticleListData: PropTypes.object.isRequired,
  getArticles: PropTypes.func.isRequired,
  querySpecification: PropTypes.object.isRequired,
};

export default ArticleList;
